import { render } from "./BoardFaq.vue?vue&type=template&id=21e7f0e4"
import script from "./BoardFaq.vue?vue&type=script&lang=js"
export * from "./BoardFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__